<form *ngIf="show.form" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate()" RestrictFocus>
    <div class="ui-grid ui-grid-responsive ui-fluid Loyalty">
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.name.nullable}">{{ validation.name.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="name" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.name"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.description.nullable}">{{ validation.description.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="description" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.description"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.vat_code.nullable}">{{ validation.vat_code.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="vat_code" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.vat_code"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.address_1.nullable}">{{ validation.address_1.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="address_1" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.address_1"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.address_2.nullable}">{{ validation.address_2.keyName }}</label></div>
            <div class="ui-grid-col-8"><input formControlName="address_2" type="text" pInputText/></div>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.address_2"></app-validation-msg>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.address_number.nullable}">{{ validation.address_number.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="address_number" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.address_number"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.contact_1.nullable}">{{ validation.contact_1.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="contact_1" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.contact_1"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.contact_2.nullable}">{{ validation.contact_2.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="contact_2" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.contact_2"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.logo.nullable}">{{ validation.logo.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="logo" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.logo"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.logo_name.nullable}">{{ validation.logo_name.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="logo_name" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.logo_name"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.url.nullable}">{{ validation.url.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="url" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.url"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.note_1.nullable}">{{ validation.note_1.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="note_1" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.note_1"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.note_2.nullable}">{{ validation.note_2.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="note_2" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.note_2"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.note_3.nullable}">{{ validation.note_3.keyName }}</label></div>
            <div class="ui-grid-col-8">
              <input formControlName="note_3" type="text" pInputText/>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.note_3"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.country_id.nullable}">{{ validation.country_id.keyName }}</label></div>
            <div class="ui-grid-col-8">
                    <p-autoComplete
                    [suggestions]="countries"
                    [(ngModel)]="model.country"
                    [ngModelOptions]="{standalone: true}"
                    (completeMethod)="filterCountrySingle($event)"
                    (onSelect)="onSelectCountry($event)"
                    placeholder="{{ 'common.country' | translate }}"
                    (onClear)="onClearCountry()"
                    [minLength]="2"
                    [required]="!validation.country_id.nullable"
                    field="name"
                    >
                  </p-autoComplete>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.country_id"></app-validation-msg>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.state_id.nullable}">{{ validation.state_id.keyName }}</label></div>
            <div class="ui-grid-col-8">
               <p-autoComplete
                [suggestions]="states"
                [(ngModel)]="model.state"
                [ngModelOptions]="{standalone: true}"
                (completeMethod)="filterStateSingle($event)"
                (onSelect)="onSelectState($event)"
                placeholder="{{ 'common.state' | translate }}"
                (onClear)="onClearState()"
                [minLength]="2"
                [required]="!validation.state_id.nullable"
                field="name"
                >
                </p-autoComplete>
                <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.state_id"></app-validation-msg>
            </div>
        </div>
    </div>
    <p-footer>
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0">
            <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
                    [label]="editingElement.id ? ('common.edit' | translate) : ('common.add' | translate)">
            </button>
        </div>
    </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/entity/entity-form.component.html